import { Navigate, useLocation } from "@tanstack/react-router";

import { useAuth } from "~/providers/auth.provider";
import { AuthState } from "~/types/auth";

interface RouteGuardProps {
  children: React.ReactNode;
}

export const RouteGuard = ({ children }: RouteGuardProps) => {
  const { authState } = useAuth();
  const location = useLocation();

  if (authState === AuthState.UNAUTHENTICATED) {
    const programMatch = location.pathname.match(/(weight-loss|urgent-care)/);
    const redirectPath = programMatch ? `/${programMatch[1]}` : "/weight-loss";

    return (
      <Navigate
        to={redirectPath}
        search={{
          redirect: location.pathname,
        }}
        aria-label="Redirecting to login page"
      />
    );
  }

  return (
    <div className="relative flex flex-1" role="main">
      {children}
    </div>
  );
};
